module.exports = __webpack_public_path__ + "media/app/containers/CheckoutPage/AddressMapIcon.6bcddeb0.svg";